/** Signed-in invitees finish their onboarding profile here. */
export const COMPLETE_REGISTRATION_PATH = '/complete-registration';
export const COMPLETE_REGISTRATION_ORG_PARAM = 'org';

const COMPLETE_REGISTRATION_REGEXP = /^\/complete-registration\/?$/;

export const isCompleteRegistrationPathname = (pathname: string): boolean =>
  COMPLETE_REGISTRATION_REGEXP.test(pathname);

/**
 * The organization the invitee is pending in travels in the URL, so the page loads that
 * invitation and not one from another organization the user is already active in.
 */
export const buildCompleteRegistrationPath = (organizationId?: string | null): string =>
  organizationId
    ? `${COMPLETE_REGISTRATION_PATH}?${COMPLETE_REGISTRATION_ORG_PARAM}=${encodeURIComponent(organizationId)}`
    : COMPLETE_REGISTRATION_PATH;

export const getCompleteRegistrationOrgId = (search: string): string | undefined =>
  new URLSearchParams(search).get(COMPLETE_REGISTRATION_ORG_PARAM) || undefined;

const REMEMBERED_PATH_KEY = 'completeRegistrationAfterSignIn';

/**
 * An existing account opening an invite link must sign in first. The form for that
 * organization is remembered for this tab and opened once after sign-in.
 */
export const rememberCompleteRegistration = (organizationId: string): void => {
  try {
    sessionStorage.setItem(REMEMBERED_PATH_KEY, buildCompleteRegistrationPath(organizationId));
  } catch {
    // Storage blocked: the invitee can open the link again once signed in.
  }
};

/** Returns the remembered form path once, clearing it. */
export const takeRememberedCompleteRegistration = (): string | null => {
  try {
    const path = sessionStorage.getItem(REMEMBERED_PATH_KEY);
    sessionStorage.removeItem(REMEMBERED_PATH_KEY);
    return path;
  } catch {
    return null;
  }
};
